import { AfterViewInit, Component, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { GridService } from 'app/services/grid.service';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConfigService } from '../../services/config.service';
import { PermissionService } from '../../services/permission-service';

import { TranslocoPipe } from '@ngneat/transloco';
import { SVGIcon } from '@progress/kendo-angular-icons';
import { Router } from '@angular/router';


@Component({
    selector: 'app-drake-toolbar',
    templateUrl: './drake-toolbar.component.html',
    styleUrls: ['./drake-toolbar.component.scss'],
    standalone: true,
    imports: [
        TranslocoPipe,
        CommonModule,
        InputsModule,
        DropDownsModule,
        UploadModule,
        DateInputsModule,
        FormsModule,
        MatIconModule,
        TranslocoPipe],
    providers: [TranslocoPipe]
})
export class DrakeToolbarComponent implements AfterViewInit, OnChanges {
    @Input() public toolbarConfig: any;
    notification: { message: string; type: 'success' | 'error' } | null = null;
    dropdownData: any[] = [];
    selectedValue: any = { text: 'Select an option', value: null };

    canInsert: boolean = false;
    canEdit: boolean = false;
    canRead: boolean = false;
    canDelete: boolean = false;
    valueInput: any = {};




    constructor(
        private gridService: GridService,
        private drakeSharedService: DrakeSharedService,
        private http: HttpClient,
        private configService: ConfigService,
        private permissionService: PermissionService,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private translocoPipe: TranslocoPipe
    ) {
        this.drakeSharedService.editableSubject.subscribe(editable => {
            this.canInsert = this.canInsert || (editable.canInsert != undefined ? editable.canInsert : true)
            this.canEdit = this.canEdit || (editable.canEdit != undefined ? editable.canEdit : true)
            this.canDelete = this.canDelete || (editable.canDelete != undefined ? editable.canDelete : true)
            this.canRead = true
            this.updateVisibility();
        });
    }


    ngAfterViewInit(): void {
        //this.getPermission();
    this.updateVisibility();


    }



    ngOnChanges(changes: SimpleChanges): void {
        console.log('ngOnChanges called', changes);
        if (changes.toolbarConfig && changes.toolbarConfig.currentValue) {
            if (this.toolbarConfig) {
                const config = this.toolbarConfig.toolbarActions;
                config.forEach((item: any) => {
                    if (item.actType == 'TXB') {
                        this.valueInput[item.actionCode] = '';
                    }
                });
            }
            console.log(this.drakeSharedService.mainRecord)
        }
        Promise.resolve().then(() => this.updateVisibility());
    }

    extractScopeFromPathname(): string {
        const parts = location.pathname.split('/');
        const scopeIndex = parts.indexOf('d') + 1;
        return parts[scopeIndex].toUpperCase() || '';
    }
    extractViewFromPathname(): string {
        const parts = location.pathname.split('/');
        const scopeIndex = parts.indexOf('v') + 1;
        return parts[scopeIndex].toUpperCase() || (this.extractScopeFromPathname() + ".DEFAULT");
    }
    extractUrlPart(part: string, defaultValue: string): string {
        const parts = location.pathname.split('/');
        const scopeIndex = parts.indexOf(part) + 1;
        return parts[scopeIndex].toUpperCase() || defaultValue;
    }

    executeAction(action: string, arg: any): void {
        
        var fn = action;
        var extraValue = null;
        if (action.includes('.'))
        {
            fn = action.split('.')[0];
            extraValue = action.split('.')[1];
        }
        this.drakeSharedService.toolbarActions[fn](arg, extraValue);
    }

    getPermission(): void {
        let scope = this.extractScopeFromPathname();
        if (scope) {
            this.permissionService.getUserPermissions(scope).subscribe((permissions: any) => {
                this.canInsert = permissions.canWrite;
                this.canEdit = permissions.canWrite;
                this.canRead = permissions.canRead;
                this.canDelete = permissions.canDelete;
                console.log('Permissions: ', permissions);
                this.updateVisibility();
            }, (error) => {
                console.error('Error fetching permissions:', error);
            });
        }
    }

    updateVisibility() {
        if (this.toolbarConfig) {
            const config = this.toolbarConfig.toolbarActions;
            
            //console.log('Toolbar Actions Config:', config); // Logga la struttura di config
            config.forEach((item: any) => {
                //;
                if (item.actExtraConditions){
                    if (item.actExtraConditions.startsWith('{')){

                        var script = JSON.parse(item.actExtraConditions).script;
                        item.actVisible = eval(script);
                    }
                    else {
                        item.actVisible = this[item.actExtraConditions];
                    }
                }
                if (item.actType === 'DRP' && item.actDrpUrl) {
                    const scope = this.extractScopeFromPathname();
                    const viewCode = this.extractViewFromPathname();
                    const actUrl = item.actDrpUrl
                        .replace('{scope}', scope)
                        .replace('{viewCode}', viewCode);
                    console.log('Calling URL:', actUrl);
                    this.configService.getDrpData(actUrl).subscribe(data => {
                        item.dropdownData = data;
                        if (item.actDrpUrlValuePrefix) {
                            item.selectedValue = this.extractUrlPart(item.actDrpUrlValuePrefix, this.extractScopeFromPathname() + "." + item.actDrpUrlValueDefault)
                        }
                        else
                            item.selectedValue = data.length ? data[0].code : null;
                        console.log('Dropdown data loaded for', item.actionName, ':', item.dropdownData);
                    });
                }

                if (item.actType === 'ARR' && item.actDrpUrl) {
                    try {
                    let src = item.actDrpUrl;

                    if (Array.isArray(src)) {
                        item.dropdownData = src;
                    } else if (typeof src === 'string') {
                        const maybeClean = src.trim().startsWith('[') ? src.replace(/\\+/g, '') : src;
                        item.dropdownData = JSON.parse(maybeClean);
                    } else {
                        console.warn('ARR: actDrpUrl non è né string né array:', src);
                        item.dropdownData = [];
                    }

                    const arr = item.dropdownData || [];
                    const def = item.actDrpUrlValueDefault;
                    if (item.actDrpUrlValuePrefix === 'a') {
                        if (def != null) {
                        const found = arr.find((x: any) => x?.code === def || x?.value === def);
                        item.selectedValue = found?.code ?? found?.value ?? null;
                        } 
                        else if (def === null || def === undefined || def === '') {
                            item.selectedValue = null;
                        }
                    } else {
                        //item.selectedValue = arr.length ? (arr[0]?.code ?? arr[0]?.value ?? null) : null;
                        item.selectedValue = null;

                    }

                    console.log('[ARR] dropdownData:', item.dropdownData, 'selectedValue:', item.selectedValue);

                    } catch (e) {
                    console.error('ARR: JSON.parse fallito per actDrpUrl:', item.actDrpUrl, e);
                    item.dropdownData = [];
                    item.selectedValue = null;
                    }
                }

                /*switch (item.actExtraConditions) {
                    case "canWrite":
                        if (this.canWrite)
                            item.actVisible = true;
                        else
                            item.actVisible = false;
                        break;
                    case "canRead":
                        if (this.canRead)
                            item.actVisible = true;
                        else
                            item.actVisible = false;
                        break
                    case "canDelete":
                        if (this.canDelete)
                            item.actVisible = true;
                        else
                            item.actVisible = false;
                        break;
                }*/
            });
            this.cdr.detectChanges();
        }
    }


    public events: string[] = [];
    //public calendarSvg: SVGIcon = calendarIcon;


    public onChange(value: KeyboardEvent, action: any): void {

        if (value.key.toUpperCase() == 'ENTER') {
            switch (action.actAction){
                case "SEARCH":
                    this.drakeSharedService.toolbarActions.SEARCH(action, this.valueInput[action.actionCode], this.translocoPipe.transform("notification.error.serialNotFound"));
                    break;
                case "CUSTOMSCRIPT":
                    this.drakeSharedService.toolbarActions.CUSTOMSCRIPT(action, this.valueInput[action.actionCode]);
                    break;
            }
        }

    }

    private log(event: string): void {
        this.events.unshift(`${event}`);
    }

}